import { Button, Col, Form, Row } from 'react-bootstrap';

const MAX_PARTS = 30;

export const emptyPartOfTerm = () => ({
    code: '',
    name: '',
    startDate: '',
    endDate: '',
});

// The term dialog's list of parts of term: the Registrar's session codes and
// names that the faculty request form offers for a section, with optional
// dates. `parts` is the dialog's state; the server replaces the stored list
// with what is saved.
function PartsOfTermEditor({ parts, onChange }) {
    const update = (index, field, value) =>
        onChange(
            parts.map((part, i) =>
                i === index ? { ...part, [field]: value } : part
            )
        );

    const columns = [
        { field: 'code', label: 'Code', md: 2, type: 'text', maxLength: 10 },
        {
            field: 'name',
            label: 'Session name',
            md: 4,
            type: 'text',
            maxLength: 100,
        },
        { field: 'startDate', label: 'Start', md: 2, type: 'date' },
        { field: 'endDate', label: 'End', md: 2, type: 'date' },
    ];

    return (
        <>
            <h6 className="text-muted mb-1">Parts of Term</h6>
            <p className="small text-muted mb-3" id="admin-parts-of-term-help">
                The sessions faculty can choose from for a section on the
                request form, with the Registrar&apos;s code and name for each.
                Dates are optional. Requests keep the code and name chosen when
                they were filed, so changing this list does not change them.
            </p>
            <Row className="d-none d-md-flex small text-muted mb-1" aria-hidden>
                {columns.map((col) => (
                    <Col md={col.md} key={col.field}>
                        {col.label}
                    </Col>
                ))}
            </Row>
            <ul
                className="list-unstyled mb-2"
                aria-describedby="admin-parts-of-term-help"
            >
                {parts.map((part, i) => (
                    <li key={i} className="border-bottom pb-2 mb-2">
                        <Row className="g-2 align-items-end">
                            {columns.map((col) => {
                                const id = `admin-part-${i}-${col.field}`;
                                return (
                                    <Col
                                        xs={col.type === 'date' ? 6 : 12}
                                        md={col.md}
                                        key={col.field}
                                    >
                                        <Form.Label
                                            htmlFor={id}
                                            className="d-md-none small mb-1"
                                        >
                                            {col.label}
                                        </Form.Label>
                                        <Form.Control
                                            id={id}
                                            size="sm"
                                            type={col.type}
                                            maxLength={col.maxLength}
                                            value={part[col.field]}
                                            required={
                                                col.field === 'code' ||
                                                col.field === 'name'
                                            }
                                            aria-label={`${col.label}, part of term ${i + 1}`}
                                            onChange={(e) =>
                                                update(
                                                    i,
                                                    col.field,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </Col>
                                );
                            })}
                            <Col xs={12} md={2}>
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="w-100"
                                    disabled={parts.length === 1}
                                    aria-label={`Remove part of term ${i + 1}`}
                                    onClick={() =>
                                        onChange(
                                            parts.filter((_, j) => j !== i)
                                        )
                                    }
                                >
                                    Remove
                                </Button>
                            </Col>
                        </Row>
                    </li>
                ))}
            </ul>
            <Button
                variant="outline-primary"
                size="sm"
                disabled={parts.length >= MAX_PARTS}
                onClick={() => onChange([...parts, emptyPartOfTerm()])}
            >
                Add part of term
            </Button>
        </>
    );
}

export default PartsOfTermEditor;
